
const accessToken = `Bearer ${localStorage.getItem('access_token')}`
export default accessToken